// import auth_reducer from "./reducer/auth_reducer";
import {reduxReducer} from './reducer'
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, reduxReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));


 const persistor = persistStore(store);

export {store, persistor};
